import { ContentWrapper } from '../../components/ContentWrapper';
import { Layout } from '../../components/Layout';
import s from './NotFoundPage.module.scss';

export const NotFoundContent = () => {
  'use memo';

  return (
    <ContentWrapper container containerWidth={1100}>
      <div className={s.notFoundText}>
        <h1 className={s.notFoundTextTitle}>404</h1>
        <p className={s.notFoundTextDescription}>Not Found</p>
      </div>
    </ContentWrapper>
  );
};

export const NotFoundPage = () => {
  'use memo';

  return (
    <Layout>
      <NotFoundContent />
    </Layout>
  );
};
